import { Flex } from 'antd';
import { memo, useMemo } from 'react';

import MetricItem from './metric-item';
import styles from './styles.module.scss';
import { sanitizeMetrics } from './utils';

import type { TMetricListProps } from './types';

const MetricList = memo(({ metrics }: TMetricListProps) => {
  const visibleMetrics = useMemo(() => sanitizeMetrics(metrics), [metrics]);

  if (visibleMetrics.length === 0) return null;

  return (
    <Flex vertical gap={8} className={styles['metric-stack']}>
      {visibleMetrics.map((metric, index) => (
        <MetricItem
          key={metric.id}
          metric={metric}
          showDivider={index < visibleMetrics.length - 1}
        />
      ))}
    </Flex>
  );
});

MetricList.displayName = 'ProductivityMetricList';

export default MetricList;
